<div nz-row>
    <div nz-col nzSpan="16" nzOffset="4" class="p-3">
        <div nz-row>
            <div nz-col nzSpan="24" [ngClass]="['p-3', 'language-status']">
              <h5 nz-typography style="margin-right: 5px;">
                Limba: {{sysLanguage}}
                <button nz-button nzType="primary" nzSize="small" (click)="changeLanguage('RO')">RO</button>
                <button nz-button nzType="default" nzSize="small" (click)="changeLanguage('EN')">EN</button>
              </h5>     
            </div>
        </div>

        <h1 nz-typography>Text Slides</h1>

        <nz-table #textSlidesTable [nzData]="textSlides" nzSize="small" [nzLoading]="loadingTextSlide" [nzFrontPagination]="false">
            <tbody>
                <ng-container *ngFor="let textData of textSlidesTable.data">
                    <tr>
                        <td>
                            <ng-container *ngIf="sysLanguage == 'RO'">
                                <div [innerHtml]="convert(textData.title)"></div>
                                <div style="font-size: 12px" [innerHtml]="convert(textData.content)"></div>
                            </ng-container>
                            <ng-container *ngIf="sysLanguage == 'EN'">
                                <div [innerHtml]="convert(textData.title_en)"></div>
                                <div style="font-size: 12px" [innerHtml]="convert(textData.content_en)"></div>
                            </ng-container>

                        </td>
                        <td style="text-align: right;"><button nz-button nzType="default" nzShape="circle" (click)="showModalTextSlide(textData.id)"><i nz-icon nzType="edit"></i></button></td>
                    </tr>
                </ng-container>
            </tbody>
        </nz-table>
        
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="16" nzOffset="4" class="p-3">
        <h1 nz-typography>KPIs</h1>

        <nz-table #kpiTable [nzData]="kpi" nzSize="small" [nzLoading]="loadingKpi" [nzFrontPagination]="false">
            <tbody>
                <ng-container *ngFor="let kData of kpiTable.data">
                    <tr *ngFor="let kcData of kData.kpiSet">
                        <td>{{ kcData.description }}</td>
                        <td style="text-align: right;"><button nz-button nzType="default" nzShape="circle" (click)="showModal(kcData.id)"><i nz-icon nzType="edit"></i></button></td>
                    </tr>
                </ng-container>
            </tbody>
        </nz-table>
        
    </div>
</div>

<nz-modal [(nzVisible)]="isVisibleModal" nzTitle="Editează parametrul KPI" nzWidth="1024px" (nzOnCancel)="handleCancel()">
    <div *nzModalContent>
        <nz-spin [nzSpinning]="modalLoading">
            <form nz-form [formGroup]="editForm" id="kpiForm" (ngSubmit)="submitFormKpi()">

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="description">Descriere</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <input nz-input formControlName="description" value="{{ editKpi.description }}" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="benchmark">Benchmark</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <!-- <textarea nz-input formControlName="benchmark" [nzAutosize]="{ minRows: 6, maxRows: 9 }">{{ editKpi.benchmark }}</textarea> -->
                        <quill-editor class="content-editor" [styles]="{'min-height': '300px', 'line-height': '50px'}" formControlName="benchmark" [placeholder]="''" [(ngModel)]="editKpi.benchmark"></quill-editor>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="greenDescription">Green desc</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <textarea nz-input formControlName="greenDescription" [nzAutosize]="{ minRows: 3, maxRows: 9 }">{{ editKpi.greenDescription }}</textarea>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="yellowDescription">Yellow desc</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <textarea nz-input formControlName="yellowDescription" [nzAutosize]="{ minRows: 3, maxRows: 9 }">{{ editKpi.yellowDescription }}</textarea>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="redDescription">Red desc</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <textarea nz-input formControlName="redDescription" [nzAutosize]="{ minRows: 3, maxRows: 9 }">{{ editKpi.redDescription }}</textarea>
                    </nz-form-control>
                </nz-form-item>

            </form>
        </nz-spin>
    </div>
    <div *nzModalFooter>
      <button nz-button nzType="default" (click)="handleCancel()">Închide</button>
      <button nz-button nzType="primary" form="kpiForm" [nzLoading]="submitButtonLoading">Salvează</button>
    </div>
</nz-modal>


<nz-modal [(nzVisible)]="isVisibleModalTextSlide" nzTitle="Editează textul" nzWidth="1024px" (nzOnCancel)="handleTextSlideCancel()">
    <div *nzModalContent>
        <nz-spin [nzSpinning]="modalTextSlideLoading">
            <form nz-form [formGroup]="editTextSlideForm" id="textSlideForm" (ngSubmit)="submitFormTextSlide()">

                <nz-form-item>
                    <nz-tag [nzColor]="'green'">Chart Type: {{ editTextSlide.chartType }}</nz-tag>
                    <nz-tag [nzColor]="'green'">Table Name: {{ editTextSlide.tableName }}</nz-tag>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="title">Title</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <ng-container *ngIf="sysLanguage == 'RO'">
                            <input nz-input formControlName="title" value="{{ editTextSlide.title }}" />
                        </ng-container>
                        <ng-container *ngIf="sysLanguage == 'EN'">
                            <input nz-input formControlName="title" value="{{ editTextSlide.title_en }}" />
                        </ng-container>
                        
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="notes">Notes</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <!-- <textarea nz-input formControlName="notes" [nzAutosize]="{ minRows: 3, maxRows: 9 }">{{ editTextSlide.notes }}</textarea> -->
                        <ng-container *ngIf="sysLanguage === 'RO'">
                            <quill-editor class="content-editor" [styles]="{'min-height': '300px', 'line-height': '50px'}" formControlName="notes" [placeholder]="''"></quill-editor>
                          </ng-container>
                        <ng-container *ngIf="sysLanguage === 'EN'">
                            <quill-editor class="content-editor" [styles]="{'min-height': '300px', 'line-height': '50px'}" formControlName="notes" [placeholder]="''"></quill-editor>
                        </ng-container>
                        
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="slideClass">Slide Class</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <input nz-input formControlName="slideClass" value="{{ editTextSlide.slideClass }}" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="chartType">Chart Type</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <input nz-input formControlName="chartType" value="{{ editTextSlide.chartType }}" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="content">Content</nz-form-label>
                    <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Test">
                        <!-- <textarea nz-input formControlName="content" [nzAutosize]="{ minRows: 6, maxRows: 9 }" >{{ editTextSlide.content }}</textarea> -->

                        <ng-container *ngIf="sysLanguage == 'RO'">
                            <quill-editor class="content-editor" [styles]="{'min-height': '300px', 'line-height': '50px'}" formControlName="content" [placeholder]="''" [(ngModel)]="editTextSlide.content"></quill-editor>
                        </ng-container>
                        <ng-container *ngIf="sysLanguage == 'EN'">
                            <quill-editor class="content-editor" [styles]="{'min-height': '300px', 'line-height': '50px'}" formControlName="content" [placeholder]="''" [(ngModel)]="editTextSlide.content_en"></quill-editor>
                        </ng-container>
                        
                    </nz-form-control>
                </nz-form-item>
            </form>
        </nz-spin>
    </div>
    <div *nzModalFooter>
      <button nz-button nzType="default" (click)="handleTextSlideCancel()">Închide</button>
      <button nz-button nzType="primary" form="textSlideForm" [nzLoading]="submitTextSlideButtonLoading">Salvează</button>
    </div>
</nz-modal>